import React from "react";
import { JAPAN_FEATURES } from "../../data/courseDataJapan";

const JapanFeatures = () => {
  return (
    <section id="jl-why" className="jl-section jl-why">
      <div className="container">
        <header className="section-header wow fadeInUp">
          <span className="jl-section-label">Koderboxが選ばれる理由</span>
          <h2 className="about_head">
            語学学習に必要なものが、
            <span className="highlighted-text">すべて揃っています</span>
          </h2>
          <p className="jl-section-subtitle">
            ライブ授業・少人数制・柔軟なスケジュールで、合格だけでなく実践力を身につけます。
          </p>
        </header>

        <div className="jl-features-grid">
          {JAPAN_FEATURES.map((feature, index) => (
            <div
              key={feature.title}
              className="jl-feature-card wow fadeInUp"
              data-wow-delay={`${index * 0.1}s`}
            >
              <div className="jl-feature-card__icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default JapanFeatures;
